import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import { useStore } from "utils/useStore";
import React from "react";
import { Stack } from "@mui/material";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import { ApplicationFilterValuesStore } from "stores/ApplicationFilters/ApplicationFilterValuesStore";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const ContactTypesChips = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);
    const applicationFilterValuesStore = useStore(ApplicationFilterValuesStore);

    const isContactTypeLabelsLoading =
        applicationFilterValuesStore.getTaskLoading(
            ApplicationFilterValuesStore.Tasks.LOAD_MAPPED_CUSTOMER_TYPES,
        );

    const contactTypeLoadingIndicator = (
        <Stack direction="row" flexWrap="nowrap" alignItems="center" spacing={1}>
            <span>Contact Type:</span>
            <AcxLoadingIndicator size={16} alternate="PuffLoader" />
        </Stack>
    );

    if (isContactTypeLabelsLoading) {
        return applicationFiltersStore.contactTypes.map((contactType) => (
            <AppliedFilterChip
                key={contactType}
                disabled={props.disabled}
                isApplicable={props.isApplicable}
            >
                {contactTypeLoadingIndicator}
            </AppliedFilterChip>
        ));
    }

    return applicationFiltersStore.contactTypes.map((contactType) => (
        <AppliedFilterChip
            key={contactType}
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() =>
                applicationFiltersStore.setContactTypes(
                    applicationFiltersStore.contactTypes.filter(
                        (type) => type !== contactType,
                    ),
                )
            }
        >
            Contact Type: {applicationFilterValuesStore.getContactTypeLabel(contactType)}
        </AppliedFilterChip>
    ));
});
